import { useQuery } from "@apollo/client"
import { MenuDivider, MenuItem } from "@blueprintjs/core"
import ActionMenu from "components/Atoms/ActionMenu"
import StyledLink from "components/Atoms/StyledLink"
import Error from "components/Common/Error"
import ReactTableHeader from "components/Common/ReactTableHeader"
import TablePagination from "components/Molecules/TablePagination"
import NewResourceButton from "components/Organisms/AddResourceButton"
import SerialColumn from "components/Organisms/table/SerialColumn"
import { DEPARTMENT_LIST } from "graphql/department.graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React from "react"
import { useNavigate } from "react-router-dom"
import ReactTable from "react-table"
import DepartmentVarietyList from "./DepartmentVarietyList"
import CustomCard from "components/Atoms/CustomCard"
export default function Departments() {
  const navigate = useNavigate()

  const COLUMNS = [
    SerialColumn,
    {
      width: 50,
      Cell({ original: { id } }) {
        return (
          <ActionMenu>
            <MenuItem
              text="Edit Department"
              icon="edit"
              onClick={e => navigate(id)}
            />
            <MenuDivider />
            <MenuItem icon="projects" text="Archive Department" />
          </ActionMenu>
        )
      },
    },
    {
      Header: "Name",
      accessor: "name",
      width: 320,
      Cell: ({ original }) => {
        return (
          <>
            {original.photo && (
              <img
                className="mr-2 inline-block"
                src={original.photo}
                alt={original.name}
                width={16}
                height={16}
              />
            )}
            <StyledLink
              to={{
                pathname: `/d/registration/department/${original.id}`,
                // state: params,
              }}
            >
              {original.name}
            </StyledLink>
          </>
        )
      },
    },
    {
      Header: "Type",
      accessor: "departmentTypeDisplay",
      width: 220,
      Cell({ original, value }) {
        return (
          <span>
            {value}{" "}
            <span className="text-muted">({original.departmentType})</span>
          </span>
        )
      },
    },
    {
      Header: "Varieties",
      accessor: "varieties.name",
      Cell({ original }) {
        return <DepartmentVarietyList varieties={original.varieties} />
      },
    },
  ]
  const [{ search, page }, setFilter] = useSearchFilter()
  const { data, loading, error } = useQuery(DEPARTMENT_LIST, {
    variables: { query: search, first: 20, skip: page * 20 },
  })
  if (error) return <Error message={error.message} />
  return (
    <CustomCard className="w-full p-0">
      <ReactTableHeader
        title="Department"
        icon="briefcase"
        value={search}
        onQueryChange={search => {
          setFilter(prev => ({
            ...prev,
            page: 0,
            search,
          }))
        }}
      >
        <TablePagination
          className="mr-3"
          page={page}
          onPageChange={page => {
            setFilter(prev => ({
              ...prev,
              page,
            }))
          }}
        />
        <NewResourceButton module="department" />
      </ReactTableHeader>

      <ReactTable
        pageSize={20}
        loading={loading}
        showPagination={false}
        className="mt-0 text-center vt-master-table"
        data={data && data.allDepartments}
        columns={COLUMNS}
      />
    </CustomCard>
  )
}
